(function ($) {
  'use strict';

  //=============================================================
  // 数量選択ウィジェット（max=0 を「上限なし」として扱う仕様対応）
  // ・min=0 かつ lot>1 の場合は、開始値を lot に補正（例：0/3→3,6,9…）
  // ・blur時の正規化は「切り上げ」スナップ（例：8→9）
  // ・未指定maxは 999 を既定上限として扱う
  //=============================================================
  function initQuantityWidgets(root) {
    var $root = root ? $(root) : $(document);
    var SELECT_LIMIT = 10;           // select の選択肢最大件数（超えたら "custom" へ）
    var DIRECT_INPUT_THRESHOLD = 10; // min がこの数以上なら input だけ表示（直入力優先）
    var DEFAULT_MAX = 999;           // ★未指定時のデフォルト最大購入数

    if (!$ || !$.fn || !$.fn.each) {
      console.error('[quantity] jQuery が見つかりません。');
      return;
    }

    function setupWidget($widget) {
      var $select = $widget.find('select.quantity-select');
      var $number = $widget.find('input.quantity-number');
      var $final  = $widget.find('input.final-quantity-input');
      var $error  = $widget.find('.quantity-error');

      if ($select.length === 0) $select = $widget.find('select').first();
      if ($number.length === 0) $number = $widget.find('input[type="number"]').first();
      if ($final.length  === 0) $final  = $('<input type="hidden" class="final-quantity-input">').appendTo($widget);
      if ($error.length  === 0) $error  = $('<div class="quantity-error" aria-live="polite"></div>').appendTo($widget);

      // data 取得
      var rawMin = toInt($widget.data('min-quantity'), 1);
      var rawMax = toInt($widget.data('max-quantity'), DEFAULT_MAX); // 未指定は 999
      var rawLot = toInt($widget.data('lot-unit'), 1);

      // 基本補正
      var lot = Math.max(1, rawLot || 1);

      // ★重要：lot縛りがある場合、minがlotより小さければlotに補正
      // 例：min=1, lot=100 → min=100（100,200,300...）
      var min;
      if (lot > 1) {
        // lot縛りがある場合は、minがlot未満ならlotを最小値にする
        min = Math.max(lot, rawMin || 1);
      } else {
        min = Math.max(1, rawMin || 1);
      }

      // 「max=0 → 上限なし」
      var openEnded = (String($widget.data('max-quantity')) === '0');
      var uiForceHybrid = openEnded;

      // セレクト表示範囲
      var max;
      if (openEnded) {
        max = min + (SELECT_LIMIT - 1) * lot;
      } else {
        max = Math.max(min, rawMax); // 未指定は 999 が入っている
      }

      // number 属性設定
      var numberAttrs = {
        'min': min,
        'step': lot,
        'value': min,
        'inputmode': 'numeric',
        'pattern': '\\d*',
        'autocomplete': 'off'
      };
      if (!openEnded) numberAttrs['max'] = max;
      $number.attr(numberAttrs);

      // 初期の確定値
      setFinal($final, min);

      //========================================
      // UIモード実装（A/B/C）＋ ロット優先ハイブリッド
      //========================================
      if (lot > 1) {
        var endForLot = Math.min(max, min + (SELECT_LIMIT - 1) * lot);

        if (uiForceHybrid) {
          buildSelectOptions($select, min, endForLot, lot);
          appendCustomOption($select, endForLot + lot);
          $number.hide();
          $select.show();
        } else {
          if (Math.floor((max - min) / lot) + 1 <= SELECT_LIMIT) {
            buildSelectOptions($select, min, max, lot);
            $number.hide();
            $select.show();
          } else {
            buildSelectOptions($select, min, endForLot, lot);
            appendCustomOption($select, endForLot + lot);
            $number.hide();
            $select.show();
          }
        }
      }
      else if (min >= DIRECT_INPUT_THRESHOLD && !uiForceHybrid) {
        // A: 直入力のみ
        $select.hide();
        $number.show();
      }
      else if (!uiForceHybrid && (Math.floor((max - min) / lot) + 1) <= SELECT_LIMIT) {
        // B: 選択肢が少ないなら select のみ
        buildSelectOptions($select, min, max, lot);
        $number.hide();
        $select.show();
      }
      else {
        // C: ハイブリッド
        var end = min + (SELECT_LIMIT - 1) * lot;
        buildSelectOptions($select, min, end, lot);
        appendCustomOption($select, end + lot);
        $number.hide();
        $select.show();
      }

      //========================================
      // イベントハンドラ
      //========================================
      // select 変更
      $select.off('change.quantity').on('change.quantity', function () {
        clearError($error);
        var val = $(this).val();
        if (val === 'custom') {
          $select.hide();
          $number.show().trigger('focus');
          var hint = toInt($(this).data('custom-start'), min + lot);
          hint = openEnded ? Math.max(hint, min) : clamp(hint, min, max);
          hint = alignUp(hint, min, lot); // ★切り上げスナップ
          $number.val(hint);
          setFinal($final, hint);
        } else {
          setFinal($final, toInt(val, min));
        }
      });

      // 入力制御：数字以外の除去
      $number.off('input.quantity').on('input.quantity', function () {
        var raw = String($(this).val() || '');
        var digits = raw.replace(/[^\d]/g, '');
        if (raw !== digits) $(this).val(digits);

        var value = toInt(digits, 0);
        if (value === 0) {
          clearError($error);
          setFinal($final, '');
          return;
        }

        if (value < min) {
          showError($error, `最小購入数は${min}個です。`);
          setFinal($final, '');
          return;
        }
        if (!openEnded && value > max) {
          showError($error, `最大購入数は${max}個です。`);
          setFinal($final, '');
          return;
        }
        if (!isValidStep(value, min, lot)) {
          showError($error, `${lot}個単位で入力してください。`);
          setFinal($final, '');
          return;
        }

        clearError($error);
        setFinal($final, value);
      });

      // blur：★端数は「切り上げ」正規化（例：8→9）
      $number.off('blur.quantity').on('blur.quantity', function () {
        var value = toInt($(this).val(), 0);
        if (value === 0) return;
        var bounded = openEnded ? Math.max(value, min) : clamp(value, min, max);
        var normalized = alignUp(bounded, min, lot);
        $(this).val(normalized);
        setFinal($final, normalized);
        clearError($error);
      });
    }

    // 初期化
    $root.find('.quantity-widget').each(function () { setupWidget($(this)); });

    //========================================
    // フォーム送信時の最終バリデーション（複数対応）
    //========================================
    $root.find('form').off('submit.quantity').on('submit.quantity', function (e) {
      var $form = $(this);
      var ok = true;
      var firstErrorField = null;

      $form.find('.quantity-widget').each(function () {
        var $w     = $(this);
        var $final = $w.find('input.final-quantity-input');
        var $error = $w.find('.quantity-error');
        var finalVal = toInt($final.val(), 0);

        var rawMin = toInt($w.data('min-quantity'), 1);
        var lot    = Math.max(1, toInt($w.data('lot-unit'), 1));
        var min    = (lot > 1) ? Math.max(lot, rawMin || 1) : Math.max(1, rawMin || 1);

        var rawMax = toInt($w.data('max-quantity'), DEFAULT_MAX);
        var openEnded = (String($w.data('max-quantity')) === '0');
        var max = openEnded ? (min + (SELECT_LIMIT - 1) * lot) : Math.max(min, rawMax);

        var localOk = true;
        if (finalVal === 0) {
          showError($error, '数量が正しくありません。');
          localOk = false;
        } else if (finalVal < min) {
          showError($error, `最小購入数は${min}個です。`);
          localOk = false;
        } else if (!openEnded && finalVal > max) {
          showError($error, `最大購入数は${max}個です。`);
          localOk = false;
        } else if (!isValidStep(finalVal, min, lot)) {
          showError($error, `${lot}個単位で入力してください。`);
          localOk = false;
        } else {
          clearError($error);
        }

        if (!localOk) {
          ok = false;
          if (!firstErrorField) {
            firstErrorField = $w.find('input.quantity-number:visible, select.quantity-select:visible').first();
          }
        }
      });

      if (!ok) {
        e.preventDefault();
        if (firstErrorField && firstErrorField.length) firstErrorField.trigger('focus');
        return false;
      }
      return true;
    });

    //=====================
    // ヘルパー群
    //=====================
    function toInt(v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? (fallback || 0) : n;
    }
    function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }
    function isValidStep(v, min, lot) { return ((v - min) % lot) === 0; }
    function alignUp(v, min, lot) { // ★切り上げスナップ
      var offset = v - min;
      var k = Math.ceil(offset / lot);
      return min + Math.max(0, k) * lot;
    }
    function setFinal($final, v) { $final.val(v); }
    function showError($el, msg) { $el.text(msg); }
    function clearError($el) { $el.text(''); }

    function buildSelectOptions($select, start, end, step) {
      var html = '';
      for (var i = start; i <= end; i += step) {
        html += '<option value="' + i + '">' + i + '</option>';
      }
      $select.html(html);
      var next = end + step;
      $select.data('custom-start', next);
    }
    function appendCustomOption($select, labelStart) {
      var label = labelStart + '+';
      $select.append('<option value="custom">' + label + '</option>');
      $select.data('custom-start', labelStart);
    }
  }

  // DOM 準備完了で初期化
  $(function () { initQuantityWidgets(document); });

  // 必要ならグローバル公開（動的挿入時に呼べます）
  window.Signmall = window.Signmall || {};
  window.Signmall.initQuantityWidgets = initQuantityWidgets;


  // reloadCotent による部分更新後の再初期化
document.addEventListener('partial:updated', function (ev) {
  if (!window.Signmall || typeof window.Signmall.initQuantityWidgets !== 'function') {
    return;
  }

  var roots = (ev.detail && ev.detail.roots) ? ev.detail.roots : [];

  roots.forEach(function (sel) {
    var root = document.querySelector(sel);
    if (!root) {
      return;
    }
    // 差し替えられた領域だけ数量ウィジェットを再初期化
    window.Signmall.initQuantityWidgets(root);
  });
});



})(window.jQuery);
